import {get, put} from "aws-amplify/api";
import config from './config-all-events';
import {fetchAuthSession} from "aws-amplify/auth";

const AllEventsApi = {
    async getByYears(userId)
    {
        const session = await fetchAuthSession().catch(() => null);
        const headers = session?.tokens?.idToken ? { Authorization: `Bearer ${session.tokens.idToken.toString()}` } : {};
        return get({apiName: config.apiName, path: config.basePath + 'all', options: {
            queryParams: {userId: userId},
            headers
        }}).response.then(response => response.body.json()).catch(error => {
            console.log('Error', error);
        });
    },

    async getByMonths(userId, year)
    {
        const session = await fetchAuthSession().catch(() => null);
        const headers = session?.tokens?.idToken ? { Authorization: `Bearer ${session.tokens.idToken.toString()}` } : {};
        return get({apiName: config.apiName, path: config.basePath + 'year', options: {
            queryParams: {userId: userId, year: year},
            headers
        }}).response.then(response => response.body.json()).catch(error => {
            console.log('Error', error);
        });
    },

    async getByDays(userId, year, month)
    {
        const session = await fetchAuthSession().catch(() => null);
        const headers = session?.tokens?.idToken ? { Authorization: `Bearer ${session.tokens.idToken.toString()}` } : {};
        return get({apiName: config.apiName, path: config.basePath + 'month', options: {
            queryParams: {userId: userId, year: year, month: month},
            headers
        }}).response.then(response => response.body.json()).catch(error => {
            console.log('Error', error);
        });
    },

    async getDay(userId, year, month, day)
    {
        const session = await fetchAuthSession().catch(() => null);
        const headers = session?.tokens?.idToken ? { Authorization: `Bearer ${session.tokens.idToken.toString()}` } : {};
        return get({apiName: config.apiName, path: config.basePath + 'day', options: {
            queryParams: {userId: userId, year: year, month: month, day: day},
            headers
        }}).response.then(response => response.body.json()).catch(error => {
            console.log('Error', error);
        });
    },

    async getLabels(userId, period, label)
    {
        console.log('getLabels');
        let dbKey = userId + '-' + period;
        let path = config.basePath + 'labels/' + dbKey;
        return get({apiName: config.apiName, path: path, options: { // OPTIONAL
            queryStringParameters: label ? {label} : null
        }}).response.then(response => response.body.json()).catch(error => {
            console.log(error.response)
        });
    },

    async getLabelsByEvent(userId, eventId)
    {
        const session = await fetchAuthSession().catch(() => null);
        const headers = session?.tokens?.idToken ? { Authorization: `Bearer ${session.tokens.idToken.toString()}` } : {};
        let path = config.basePath + 'labels/' + userId + '/event/' + eventId;
        return get({apiName: config.labelsApiName, path: path, options: { headers }}).response.then(response => response.body.json()).catch(error => {
            console.log(error.response)
        });
    },

    async setDateLabel(userId, period, label, image, transform, eventId)
    {
        let dbKey = userId + '-' + period;
        let requestOptions = { // OPTIONAL
            headers: { Authorization: `Bearer  ${(await fetchAuthSession()).tokens.idToken.toString()}` },
            body: {userimage: image, userId: userId, ...(transform && { transform }), ...(eventId && { eventId })},
        };
        let path = config.basePath + 'labels/' + dbKey + '/' + label;
        return put({apiName: config.labelsApiName, path: path, options: requestOptions}).response.then(response => response.body.json()).catch(error => {
            console.log(error.response)
        }).catch(error => {
            //TODO catch
        });
    }
}
export default AllEventsApi;
